if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"@pdfcompare/host-service-views","remotes":[]},
		chunkMatcher: function(chunkId) {return true},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}